import 'css-chunksrc/client/pages/capacityPage/toolbar/yearNavigation/years/styles.scss';export default {
  "calendar": "_calendar_3jezx_1",
  "heading": "_heading_3jezx_7",
  "title": "_title_3jezx_18",
  "iconBox": "_iconBox_3jezx_27",
  "icon": "_icon_3jezx_27",
  "rightIcon": "_rightIcon_3jezx_48",
  "leftIcon": "_leftIcon_3jezx_52",
  "main": "_main_3jezx_56",
  "years": "_years_3jezx_60",
  "row": "_row_3jezx_65",
  "year": "_year_3jezx_60",
  "selected": "_selected_3jezx_92"
};